import gsap from "gsap";
// const axios = require('axios');

import SlimSelect from 'slim-select'

export default class Form {

    constructor(){

      const customSlcItem = document.querySelectorAll('.wpcf7-form-control.wpcf7-select, .custom-form-select');

      for (const selectS of customSlcItem) {
          selectS.querySelectorAll('option')[0].setAttribute('value', '');
          var placeholder = selectS.querySelectorAll('option')[0].innerText;
          var appendHTML = '<div class="js-select relative"><div class="js-select-title select-title text-sm text-gray-2 px-4 py-3 relative cursor-pointer overflow-hidden pr-10 w-full rounded-lg"><h5 class="whitespace-nowrap overflow-hidden text-sm !my-0 font-body" data-placeholder="' + placeholder + '">' + placeholder + '</h5><span class="absolute right-4 top-5 w-2 h-1"><svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1C7.66667 1.2087 5 2.30087 5 5" stroke="black" stroke-width="1.5" /><path d="M1 1.07031C2.32833 1.27543 4.98498 2.34889 4.98498 5.00176" stroke="black" stroke-width="1.5" /></svg> </span></div><div class="js-select-content border px-4 py-3 text-sm mt-1 absolute top-14 left-0 w-full opacity-0 bg-white rounded-lg">';
          for (const optionI of selectS.querySelectorAll('option')) {
              var val = optionI.getAttribute('value');
              if (val) {
                  appendHTML += '<label class="flex flex-row items-center mb-2.5 last:mb-0 cursor-pointer"><input class="js-form-field js-form-field-custom js-form-checkbox form-checkbox appearance-none bg-gray-1 mr-3 w-4 h-4 flex-none" type="checkbox" value="' + val + '" /><span>' + val + '</span></label>';
              }

          }

          appendHTML += '</div>';
          var div = document.createElement("div");
          div.innerHTML = appendHTML;
          selectS.after(div);

      }

      // const inquirePopup = document.getElementById('inquirePopup');
      //
      // if (inquirePopup) {
      //     const genderSelect = document.querySelector('#your-gender');
      //     console.log(genderSelect)
      //     if (genderSelect) {
      //         new SlimSelect({
      //             select: '#your-gender',
      //             settings: {
      //                 showSearch: false,
      //             }
      //         })
      //     }
      //     // new SlimSelect({
      //     //     select: '#whereDidYouHearAboutUs',
      //     //     settings: {
      //     //         showSearch: false,
      //     //     }
      //     // })
      //
      // }




      this.setupSelectors();
      this.checkboxSetup();
      this.openClose();
      this.switchCitiesSetup();
      this.openForm();
      this.closeForm();

      if (!this.forms) return;
      this.setupForm();
    }
  
    setupSelectors() {
      this.selectedCheckboxClassname = 'js-form-checkbox';
      this.selectContentClassname = 'js-select-content';
      this.selectTitleClassname = 'js-select-title';
      this.selectedCheckboxs = document.querySelectorAll( '.' + this.selectedCheckboxClassname );
      this.selectTitles = document.querySelectorAll( '.' + this.selectTitleClassname );
      this.switchCitys = document.querySelectorAll( '.js-switch-city' );
      this.switchCityContent = document.querySelectorAll( '.js-switch-city-content' );
      this.openFormButtons = document.querySelectorAll( '.js-open-form' );
      this.closeFormButtons = document.querySelectorAll( '.js-form-close' );
      this.forms = document.querySelectorAll('.js-form');
      this.formFields = document.querySelectorAll('.js-form-field');
      this.formLoaders = document.querySelectorAll('.js-form-loader');
      this.formSubmitBtn = document.querySelector('.js-form-submit');
      this.formContainer = document.querySelector('.js-form-container');
      this.formArea = document.querySelector('.js-form-area');
      this.formSuccess = document.querySelector('.js-success-icon');
      this.formCancel = document.querySelectorAll('.js-form-cancel');
      this.formClose = document.querySelector('.js-form-close');
      this.usedCity = document.querySelector('.js-city-on');
      this.errorMessages = document.querySelectorAll('.js-error-msg');
    }
  
    setupForm() {

      for(const form of this.forms){
  
        this.openFormSubmitButton(form);
  
        form.addEventListener('submit', (event) => {
          event.preventDefault();
  
          const formData = new FormData(form);
          const self = this;
          let error = 0;
          const selectContent = form.querySelectorAll('.js-select');
  
          this.clearErrorMsg();
  
          for(const select of selectContent){
            const checkboxes = select.querySelectorAll('.js-form-checkbox');
            for(const checkbox of checkboxes){
              if(checkbox.checked === true){
                formData.append(checkbox.name, checkbox.value);
                error = +1;
              }
            }
            
            if(error === 0){
              select.classList.add('error-input');
            }else{
              select.classList.remove('error-input');
            }
          }
  
          if(error === 0){
            return false;
          }
  
          grecaptcha
          .execute('6LfObbMeAAAAAL6WwTVh7q90xvZhEwOejGpnRoGg', {
              action: 'submit',
            })
            .then(function (token) {

              formData.append('token', token);
  
              formData.append('nonce', ajaxObject.nonce);
              self.sendForm(formData);
              self.toggleLoader(true);
            }) 
            .catch((error) => {
              if (error) {
                alert(
                  'Recaptcha connect lost, try again!'
                );
                return;
              }
            });
        });
  
      }
  
      for(const cancel of this.formCancel){
        cancel.addEventListener('click', () => {
          this.formClose.click();
        });
      }
    }
  
    clearErrorMsg(){
      for(const errorMessage of this.errorMessages){
        const input = errorMessage.parentElement.querySelector('.error-input');
        errorMessage.textContent = '';
        if(input !== null){
          input.classList.remove('error-input');
        }
      }
    }
  
    toggleLoader(toggle) {
      for(const formLoader of this.formLoaders){
        if (toggle === true) {
          formLoader.classList.remove('hidden');
        } else {
          formLoader.classList.add('hidden');
        }
      }
    }
  
    sendForm(formData) {
      axios({
        method: 'post',
        url: `${ajaxObject.homeUrl}/wp-json/web/v1/submit-requests`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-WP-Nonce': ajaxObject.nonce,
        },
      })
        .then((response) => {
          this.toggleLoader(false);
          this.displaySuccess();
        })
        .catch((error) => {
          if (error.response?.data?.errors?.length < 1) {
            alert(
              'Something went wrong, contact us via email: vilnius@email.com'
            );
            return;
          }
          this.toggleLoader(false);
          this.handleInvalidFields(error.response?.data?.errors);
        });
    }
  
    handleInvalidFields(invalidFields) {
      for (const slug in invalidFields) {
        if (Object.hasOwnProperty.call(invalidFields, slug)) {
          const invalidField = Array.from(this.formFields).find(
            (input) => input.id === slug
          );
  
          const error = invalidFields[slug];
          if (error !== 'empty' && invalidField.nextElementSibling) {
            invalidField.nextElementSibling.textContent = error;
          }
          if (invalidField) {
            invalidField.classList.add('error-input');
          }
        }
      }
    }
  
    displaySuccess() {
      const success = document.querySelector('.js-success');
      document.querySelector('.js-form-submit').querySelector('span').remove();
      document.querySelector('.js-form-submit').textContent = '';
      document.querySelector('.js-form-submit').append(success);
      success.classList.remove('hidden');
      this.clearInputs();
    }

    clearInputs() {
      /// inputs 
      for(const field of this.formFields){
        field.value = '';
      }

      // textarea
      this.formContainer.querySelector('textarea[name=message]').value = '';
    }
  
    openFormSubmitButton(form){
      const checkboxPP = form.querySelector('.js-pp-checkbox');
      const formButton = form.querySelector('.js-form-submit');
      const currentCity = form.querySelector('.js-current-city');
      const selectContent = form.querySelectorAll('.js-select');

      for(const select of selectContent){
        const checkboxes = select.querySelectorAll('.js-form-checkbox');
        for(const checkbox of checkboxes){
          if(checkbox.value.toLowerCase() === currentCity.value.toLowerCase()){
            const container = checkbox.parentElement.parentElement;
            const title = container.parentElement.querySelector('h5');
            checkbox.click();
            title.click();
          }
        }
      }
  
      formButton.disabled = true;
      formButton.classList.add('disabled');
      
      checkboxPP.addEventListener('change', function () {
  
        const formFields = form.querySelectorAll('.js-form-field');

        if(checkboxPP.checked){
          formButton.disabled = false;
          formButton.classList.remove('disabled');
        }else{
          formButton.disabled = true;
          formButton.classList.add('disabled');
        }

        // let error        = 0; 
        // if (formFields) {
        //   for (const field of formFields) {
        //     field.value === '' ? error++ : 0;
        //   }
        // }
        // if(error === 0){
        //  formButton.disabled = false;
        //  formButton.classList.remove('disabled');
        // }else{
        //   checkboxPP.checked = false;
        //   formButton.disabled = true;
        //   formButton.classList.add('disabled');
        // }
  
        // if (!checkboxPP.checked) {
        //   formButton.disabled = true;
        //   formButton.classList.add('disabled');
        // }
      });
    }



    openForm() {
        for(const button of this.openFormButtons){
        button.addEventListener('click', () => {
            if(button.getAttribute('data-openid') !== ''){
            const id = button.getAttribute('data-openid');
            for(const switchCity of this.switchCitys) {
                if(switchCity.getAttribute('data-id') === id){
                switchCity.click();
                }
            }
            }
            this.formContainer.classList.remove('hidden');
            document.querySelector('html').style.overflow = 'hidden';
        });
        }
    }

    closeForm() {
        for(const button of this.closeFormButtons){
        button.addEventListener('click', () => {
            this.formContainer.classList.add('hidden');
            document.querySelector('html').style.overflow = '';
        });
        }
    }

    switchCitiesSetup() {
        for(const switchCity of this.switchCitys) {
        switchCity.addEventListener('click', () => {
            const id = switchCity.getAttribute('data-id');
            const content = document.getElementById(id);

            for(const contentSwitch of this.switchCityContent){
            contentSwitch.classList.remove('block');
            contentSwitch.classList.add('hidden');
            }

            for(const city of this.switchCitys){
            city.classList.remove('active');
            }

            content.classList.remove('hidden');
            content.classList.add('block');
            switchCity.classList.add('active');

        });
        }
    }

    checkboxSetup() {
        // console.log('checkboxSetup')

        // console.log(this.selectedCheckboxs)

        for(const selectedCheckbox of this.selectedCheckboxs) {

        selectedCheckbox.addEventListener('change', (event) => {
            console.log('change')

            event.preventDefault();

            const container = selectedCheckbox.parentElement.parentElement;
            console.log(container.parentElement.parentElement.parentElement)
            const checkboxs = container.querySelectorAll( '.' + this.selectedCheckboxClassname);
            const title = container.parentElement.querySelector('h5');

            if(selectedCheckbox.checked === true) {
            title.textContent =  selectedCheckbox.parentElement.textContent;
            title.classList.add('text-black');
            }else{
            title.textContent = title.getAttribute('data-placeholder');
            title.classList.remove('text-black');
            }

            title.click();

            for(const checkbox of checkboxs){
            if(checkbox.checked === true && checkbox.id !== selectedCheckbox.id){
                checkbox.checked = false
            }
            }
        });

        }
    }

    openClose(){

        document.onclick = (e) => {

          if(!this.selectTitles) {
            return false;
          }

          for(const title of this.selectTitles){
            const container = e.target.closest('.js-select');
            if(!container && title.classList.contains('opened')){
              title.click();
            }
          }
        }

        for(const title of this.selectTitles){

        title.addEventListener('click', () => {
            const container = title.parentElement;
            const titleArrow = title.querySelector('span');
            const content = container.querySelector('.' + this.selectContentClassname);
            
            if(!title.classList.contains('opened')){

            gsap.to(content, {
                opacity: 1,
                top: '50px',
                zIndex: 10,
                duration: 0.3
            });

            gsap.to(titleArrow, {
                duration: 0.3,
                rotate: '180deg'
            });

            for(const otherTitle of this.selectTitles){
                if(otherTitle.classList.contains('opened')){
                otherTitle.click();
                }
            }

            }else{

            gsap.to(content, {
                opacity: 0,
                top: '30px',
                zIndex: 0,
                duration: 0.2
            });

            gsap.to(titleArrow, {
                duration: 0.2,
                rotate: '0deg'
            });

            }
            title.classList.toggle('opened');
        });

        }

    }
  
}